import { RESET_STATE } from 'store/global/actions';

import { LEAD_ACTION_TYPE } from '../actions/lead.actions';

const initialState = {};

const leadApplicationReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LEAD_ACTION_TYPE.GET_LEAD_DATA:
    case LEAD_ACTION_TYPE.EDIT_LEAD:
      return payload || state;

    case LEAD_ACTION_TYPE.RESET_LEAD_DATA:
    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default leadApplicationReducer;
